import type { ZoomButtonCalloutProps } from './components/ZoomButtonsCallout';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CustomZoom" */ './lazyIndex'),
    { name: 'CustomZoom' }
);

// Delayed Loaded Components
export const ZoomButtonsCallout: LazyComponent<ZoomButtonCalloutProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.ZoomButtonsCallout);

// Getters
export { getZoomStyle } from './utils/getZoomStyle';

// Datapoints
export { default as logEmbiggenZoomSettingDatapoint } from './utils/logEmbiggenZoomSettingDatapoint';

// Events
export { default as onWheelZoom } from './utils/onWheelZoom';
export { default as onCtrlZoom } from './utils/onCtrlZoom';
export {
    onPinchZoomStart,
    onPinchZoomMove,
    onPinchZoomEnd,
    resetPinchZoom,
} from './utils/onPinchZoom';

// Lazy Actions
export const lazyOverrideCustomZoomToDefaultSideMargins: LazyAction<
    typeof lazyIndex.overrideCustomZoomToDefaultSideMargins,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.overrideCustomZoomToDefaultSideMargins);
export const lazyOverrideCustomZoomToDefaultInfoBar: LazyAction<
    typeof lazyIndex.overrideCustomZoomToDefaultInfoBar,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.overrideCustomZoomToDefaultInfoBar);
